import React from 'react';
import { Pencil1Icon } from '@radix-ui/react-icons';
import {
    BadgeCheckIcon,
    ChevronRightIcon,
    ChevronsRightIcon,
    Info,
    ShieldAlert,
    TrashIcon,
    XIcon,
    Play,
    Pause,
    Upload,
} from 'lucide-react';
import { AlertIconType } from './alert.types';

/* Set icons */
const iconMap: Record<AlertIconType, React.ElementType> = {
    'caret-right': ChevronRightIcon,
    'chevrons-right': ChevronsRightIcon,
    badge: BadgeCheckIcon,
    info: Info,
    pencil: Pencil1Icon,
    shield: ShieldAlert,
    trash: TrashIcon,
    play: Play,
    pause: Pause,
    x: XIcon,
    upload: Upload,
};

export const iconComponent = (icon?: AlertIconType): React.ReactNode => {
    if (icon === undefined) {
        return null;
    }

    const IconComponent = iconMap[icon];
    return <IconComponent />;
};
